import React from 'react';
import classnames from 'classnames';
import s from './ThumbOverlayBackground.scss';

interface Props {
  type: 'solid' | 'gradient';
  className?: string;
}

const ThumbOverlayBackground: React.FC<Props> = ({ type, className }) => (
  <div className={classnames(s['root'], s[type], className)} />
);
ThumbOverlayBackground.displayName = 'ThumbOverlayBackground';

export default ThumbOverlayBackground;
